import { selectCheckList,selectCheckRate,selectStateRate,selectCarCheck,insertCarCheck,updateCarCheck,deleteCarCheck,moveCarCheck,selectSpotCheck,selectSpotCheckStatement,insertSpotCheck,querySpotCheckReport } from "../../api/config/modules/checkManagement";

const state = {
    selectCarCheck: {},
    insertCarCheck: {},
    updateCarCheck: {},
    deleteCarCheck: {},
    moveCarCheck: {},
    selectCheckList: {},
    selectCheckRate: {},
    selectStateRate: {},
    selectSpotCheck: {},
    selectSpotCheckStatement: {},
    insertSpotCheck: {},
    querySpotCheckReport: {}
};

const mutations = {
  SET_SELECTCARCHECK: (state, selectCarCheck) => {
    state.selectCarCheck = selectCarCheck;
  },
  SET_INSERTCARCHECK: (state, insertCarCheck) => {
    state.insertCarCheck = insertCarCheck;
  },
  SET_UPDATECARCHECK: (state, updateCarCheck) => {
    state.updateCarCheck = updateCarCheck;
  },
  SET_DELELECARCHECK: (state, deleteCarCheck) => {
    state.deleteCarCheck = deleteCarCheck;
  },
  SET_MOVECARCHECK: (state, moveCarCheck) => {
    state.moveCarCheck = moveCarCheck;
  },
  SET_SELECTCHECKLIST: (state, selectCheckList) => {
    state.selectCheckList = selectCheckList;
  },
  SET_SELECTCHECKRATE: (state, selectCheckRate) => {
    state.selectCheckRate = selectCheckRate;
  },
  SET_SELECTSTATERATE: (state, selectStateRate) => {
    state.selectStateRate = selectStateRate;
  },
  SET_SELECTSPOTCHECK: (state, selectSpotCheck) => {
    state.selectSpotCheck = selectSpotCheck;
  },
  SET_SELECTSPOTCHECKSTATEMENT: (state, selectSpotCheckStatement) => {
    state.selectSpotCheckStatement = selectSpotCheckStatement;
  },
  SET_INSERTSPOTCHECK: (state, insertSpotCheck) => {
    state.insertSpotCheck = insertSpotCheck;
  },
  SET_QUERYSPOTCHECKREPORT: (state, querySpotCheckReport) => {
    state.querySpotCheckReport = querySpotCheckReport;
  },
};

const actions = {
  GET_SELECTCARCHECK: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectCarCheck(data)
        .then((res) => {
          commit("SET_SELECTCARCHECK", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTCARCHECK: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertCarCheck(data)
        .then((res) => {
          commit("SET_INSERTCARCHECK", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATECARCHECK: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateCarCheck(data)
        .then((res) => {
          commit("SET_UPDATECARCHECK", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELELECARCHECK: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteCarCheck(data)
        .then((res) => {
          commit("SET_DELELECARCHECK", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_MOVECARCHECK: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      moveCarCheck(data)
        .then((res) => {
          commit("SET_DELELECARCHECK", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCHECKLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCheckList(data)
        .then((res) => {
          commit("SET_SELECTCHECKLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCHECKRATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCheckRate(data)
        .then((res) => {
          commit("SET_SELECTCHECKRATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTSTATERATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectStateRate(data)
        .then((res) => {
          commit("SET_SELECTSTATERATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTSPOTCHECK: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectSpotCheck(data)
        .then((res) => {
          commit("SET_SELECTSPOTCHECK", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTSPOTCHECKSTATEMENT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectSpotCheckStatement(data)
        .then((res) => {
          commit("SET_SELECTSPOTCHECKSTATEMENT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTSPOTCHECK: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      insertSpotCheck(data)
        .then((res) => {
          commit("SET_INSERTSPOTCHECK", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYSPOTCHECKREPORT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      querySpotCheckReport(data)
        .then((res) => {
          commit("SET_QUERYSPOTCHECKREPORT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
